import { render } from "./DeviceLogin.vue?vue&type=template&id=e5d5cef2"
import script from "./DeviceLogin.vue?vue&type=script&lang=js"
export * from "./DeviceLogin.vue?vue&type=script&lang=js"

import "./DeviceLogin.vue?vue&type=style&index=0&id=e5d5cef2&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__